import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import { setShowCreateRoomsInventory } from "../redux-state/features/inventory/inventorySlice";
import { useSelector, useDispatch } from "react-redux";
import UsePLaceSelectionForm from "./usePlaceSelectionForm";
import BeneficairySelectionForm from "./beneficiary-selection-form";
import InventoryItemsSelect from "./inventory-items-Select";
import axios from "axios";
import urls from "../urls";
import { showError, showSuccess } from "../utils";

function CreateRoomsInventory() {
  const dispatch = useDispatch();
  const show = useSelector(
    (state) => state.inventoryState.showCreateRoomsInventory
  );
  const faculty_id = useSelector((state) => state.userState.faculty_id);
  const [selectedUsePlace, setSelectedUsePlace] = useState(null);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
  const [inventoryItems, setInventoryItems] = useState([]); // Stores selected inventory items
  const [notes, setNotes] = useState(""); // Stores temporary note

  const handleClose = () => dispatch(setShowCreateRoomsInventory(false));

  const handleInventorySelect = (selectedItem) => {
    if (!selectedItem) return;

    // Check if the item is already in the state
    if (!inventoryItems.find((item) => item.value === selectedItem.value)) {
      setInventoryItems([...inventoryItems, { ...selectedItem, notes }]);
      setNotes(""); // Clear textarea after adding the item
    }
  };

  const handleDeleteItem = (itemId) => {
    setInventoryItems(inventoryItems.filter((item) => item.value !== itemId));
  };

  const handleSave = () => {
    axios
      .post(urls.addInventoryUsage, {
        use_place_id: selectedUsePlace.value,
        beneficiary_id: selectedBeneficiary.value,
        items: inventoryItems,
        faculty_id,
      })
      .then((res) => {
        console.log(res.data);
        showSuccess("تم إضافة الجرد بنجاح ");
      })
      .catch((err) => {
        showError("لم يتم أضافة الجرد بنجاح");
        console.log(err);
      });
    // Perform save logic here

    handleClose(); // Close modal after saving
  };

  // Disable Save button if any required selection is missing
  const isSaveDisabled =
    !selectedUsePlace || !selectedBeneficiary || inventoryItems.length === 0;

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "16px" }}>
          إنشاء جرد للقاعات
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UsePLaceSelectionForm onSelect={setSelectedUsePlace} />
        <BeneficairySelectionForm onSelect={setSelectedBeneficiary} />
        <InventoryItemsSelect onSelect={handleInventorySelect} />

        {/* General Notes Text Area (Used for next item selection) */}
        <Form.Group className="mt-3">
          <Form.Label>ملاحظات للعناصر الجديدة</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="أضف ملاحظة للعنصر قبل تحديده"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </Form.Group>

        {/* Table to display selected inventory items */}
        {inventoryItems.length > 0 && (
          <Table striped bordered hover className="mt-3">
            <thead>
              <tr className="text-center">
                <th>#</th>
                <th>التعيين</th>
                <th>ملاحظات</th>
                <th>حذف</th>
              </tr>
            </thead>
            <tbody>
              {inventoryItems.map((item, index) => (
                <tr className="text-center" key={item.value}>
                  <td>{index + 1}</td>
                  <td className="text-truncate" style={{ maxWidth: "150px" }}>
                    {item.label}
                  </td>
                  <td className="text-truncate" style={{ maxWidth: "200px" }}>
                    {item.notes || "لا توجد ملاحظات"}
                  </td>
                  <td>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDeleteItem(item.value)}
                    >
                      حذف
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          إغلاق
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={isSaveDisabled}
        >
          حفظ التغييرات
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateRoomsInventory;
